export function isEnabledDevLogin(): boolean {
  const hostname = location.hostname
  console.debug(`hostname is ` + hostname);
  return hostname !== undefined
    && hostname !== null
    && (
      hostname === 'localhost' ||
      hostname === 'hu-iao.mmj.ne.jp' ||
      hostname === 'iao-staging.mmj.ne.jp' ||
      hostname === 'hu-iao.staging.mmj.ne.jp' ||
      hostname === 'hu-iao.test.mmj.ne.jp'
    )
}

export function isEnabledEditProgramType(): boolean {
  return isLocal()
}

export function isEnabledAdminExcelDownload(): boolean {
  return isLocal()
}

function isLocal(): boolean {
  const hostname = location.hostname
  console.debug(`hostname is ` + hostname);
  return hostname !== undefined
    && hostname !== null
    && (
      hostname === 'localhost' ||
      hostname === 'hu-iao.test.mmj.ne.jp'
    )
}
